export default __webpack_public_path__ + "static/media/humsafarlogo.484cf690.png";